import { apiService } from '@/services/api/api.service';
import type {
  LoginCredentials,
  LoginResponse,
  ForgotPasswordRequest,
  ResetPasswordRequest,
  UserInfo,
} from '../types/auth.types';

export const login = async (
  credentials: LoginCredentials
): Promise<LoginResponse> => {
  const formData = new URLSearchParams();
  formData.append('username', credentials.username);
  formData.append('password', credentials.password);

  return apiService.post<LoginResponse>(
    '/login/access-token',
    formData.toString(),
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }
  );
};

export const logout = async (): Promise<void> => {
  await apiService.post('/login/logout');
};

export const forgotPassword = async (
  data: ForgotPasswordRequest
): Promise<void> => {
  const formData = new URLSearchParams();
  formData.append('email', data.email);

  return apiService.post('/login/forgot-password', formData.toString(), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
};

export const resetPassword = async (
  data: ResetPasswordRequest
): Promise<void> => {
  const formData = new URLSearchParams();
  formData.append('new_password', data.new_password);
  formData.append('token', data.token);

  return apiService.post('/login/forgot-password-reset', formData.toString(), {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
};

export const getUserInfo = async (): Promise<UserInfo> => {
  return apiService.get<UserInfo>('/login/me');
};
